"use client";

import { ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function Gamingfreedomprotocol() {
  const prefersReducedMotion = useReducedMotion();
  const fadeUp = prefersReducedMotion ? {
    initial: {
      opacity: 1,
      y: 0
    },
    whileInView: {
      opacity: 1,
      y: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 12
    },
    whileInView: {
      opacity: 1,
      y: 0
    }
  };
  const cards = [{
    key: "security",
    eyebrow: "Global Servers",
    title: "Secure Access",
    description: "Military-grade encryption protocols ensuring your digital footprint remains invisible across all global networks.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_secure_tunnel.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_secure_tunnel.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_secure_tunnel.webp-wvc-sizes",
      alt: "Abstract digital tunnel representing secure encrypted data transmission"
    },
    href: "/VpnGenixPage"
  }, {
    key: "privacy",
    eyebrow: "Zero Logging",
    title: "Total Privacy",
    description: "Strict no-logs policy verified by independent audits to guarantee your browsing history stays strictly yours.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_privacy_shield.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_privacy_shield.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_privacy_shield.png-wvc-sizes",
      alt: "Digital shield icon protecting personal data in a virtual environment"
    },
    href: "/VpnGenixPage"
  }, {
    key: "speed",
    eyebrow: "Ultra Fast",
    title: "High Velocity",
    description: "Optimized server infrastructure delivering lightning-fast speeds for seamless 4K streaming and gaming.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_speed_nodes.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_speed_nodes.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpngenix_speed_nodes.webp-wvc-sizes",
      alt: "Network nodes glowing with high-speed data connections"
    },
    href: "/VpnGenixPage"
  }];
  return <section data-section-id="27652" id="gamingfreedomprotocol" data-nav="light" className="relative bg-background text-foreground py-32 md:py-44">
      {}
      <div aria-hidden="true" className="absolute top-0 left-1/2 -translate-x-1/2 h-px w-24" style={{
      backgroundColor: "var(--primary)"
    }} />

      <div className="mx-auto w-full max-w-[1360px] px-5 sm:px-8 lg:px-12">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-8">
          <motion.div {...fadeUp} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.7,
          ease: [0.2, 0.6, 0.2, 1]
        }} className="lg:col-span-7">
            <p className="font-serif italic uppercase text-xs md:text-sm mb-6" style={{
            color: "var(--primary)",
            letterSpacing: "0.14em",
            fontVariant: "small-caps"
          }}>
              <span aria-hidden="true" className="inline-block align-middle h-px w-6 mr-3" style={{
              backgroundColor: "var(--primary)"
            }} />
              Gaming Freedom
            </p>
            <h2 className="font-serif text-foreground" style={{
            fontSize: "clamp(2rem, 4.2vw, 4rem)",
            fontWeight: 400,
            letterSpacing: "-0.015em",
            lineHeight: 1.08
          }}>
              Unrestricted Access, Always <em className="italic font-serif">Protected</em>
            </h2>
          </motion.div>

          <motion.div {...fadeUp} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.7,
          ease: [0.2, 0.6, 0.2, 1],
          delay: prefersReducedMotion ? 0 : 0.08
        }} className="lg:col-span-5 mt-10 lg:mt-4">
            <div className="font-sans" style={{
            maxWidth: "480px",
            color: "var(--muted-foreground)",
            fontSize: "clamp(1rem, 1.05vw, 1.0625rem)",
            lineHeight: 1.65,
            letterSpacing: "0.005em"
          }}>
              <p className="mb-5">
                VPNGENIX is not just a tool; it is your gateway to a borderless internet. 
                We provide robust infrastructure that bypasses geo-restrictions while 
                maintaining the highest standards of digital security.
              </p>
              <p className="mb-8">
                Our servers are engineered for performance, ensuring that your 
                connection remains stable and private. Whether you are gaming, 
                streaming, or working, we ensure your data stays encrypted and 
                your identity remains anonymous.
              </p>
              <Link to="/VpnGenixPage" className="font-serif italic underline decoration-1 underline-offset-4 transition-colors duration-300 hover:text-[var(--primary)]" style={{
              color: "var(--foreground)",
              fontSize: "clamp(1rem, 1.05vw, 1.0625rem)"
            }}>
                View our security standards
              </Link>
            </div>
          </motion.div>
        </div>

        {}
        <div className="mt-24 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, i) => <motion.article key={card.key} data-index={i} initial={prefersReducedMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.7,
          ease: [0.2, 0.6, 0.2, 1],
          delay: prefersReducedMotion ? 0 : i * 0.08
        }} className="group relative flex flex-col" style={{
          backgroundColor: "var(--card)"
        }}>
              {}
              <div className="relative overflow-hidden" style={{
            aspectRatio: "3 / 4"
          }}>
                <img src={card.image.src} data-wvc-srcset={card.image.srcset} data-wvc-sizes={card.image.sizes} alt={card.image.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
              </div>

              <div className="flex flex-1 flex-col p-6 md:p-8">
                {}
                <p className="font-serif italic uppercase text-xs mb-5 flex items-center" style={{
              color: "var(--primary)",
              letterSpacing: "0.14em",
              fontVariant: "small-caps"
            }}>
                  <span aria-hidden="true" className="inline-block h-px w-6 mr-3" style={{
                backgroundColor: "var(--primary)"
              }} />
                  {card.eyebrow}
                </p>

                <h3 className="font-serif text-foreground mb-4" style={{
              fontSize: "clamp(1.15rem, 1.6vw, 1.5rem)",
              fontWeight: 400,
              letterSpacing: "-0.005em",
              lineHeight: 1.25
            }}>
                  {card.title}
                </h3>

                <p className="font-sans mb-8" style={{
              color: "var(--muted-foreground)",
              fontSize: "clamp(1rem, 1.05vw, 1.0625rem)",
              lineHeight: 1.65
            }}>
                  {card.description}
                </p>

                <div className="mt-auto pt-6">
                  <Link to={card.href} className="group/link inline-flex items-center gap-2 font-sans uppercase text-xs text-foreground transition-colors duration-300 hover:text-[var(--primary)]" style={{
                letterSpacing: "0.14em"
              }}>
                    <span className="relative">
                      Connect
                      <span aria-hidden="true" className="absolute left-0 -bottom-1.5 h-px w-full origin-right transition-transform duration-300 ease-out group-hover/link:scale-x-125" style={{
                    backgroundColor: "var(--primary)"
                  }} />
                    </span>
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover/link:translate-x-1" strokeWidth={1} />
                  </Link>
                </div>
              </div>

              {}
              <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-full" style={{
            backgroundColor: "var(--border)"
          }} />
              <span aria-hidden="true" className="absolute bottom-0 left-0 h-px w-full origin-left scale-x-0 transition-transform duration-[400ms] ease-out group-hover:scale-x-100" style={{
            backgroundColor: "var(--primary)"
          }} />
            </motion.article>)}
        </div>
      </div>
    </section>;
}